/*
** 스크립트 정의
*/
const footerModule = {
  init: function() {
    this.go_to_top();
  },
  go_to_top: function () {
    const btns = document.querySelectorAll('.go-top-btn');
    btns.forEach(btn => {
      btn.addEventListener('click', () => {
        window.scrollTo(0, 0);
      });      
    });
  }
};
footerModule.init();